import { isBrowser } from 'browser-or-node';
import pkg from '../../package.json';

const version = pkg.version;

export const chocotvWeb = { // 若使用 chocomemberHost，參數 appId 的值實為 chocomemberAppId 的值！
  appId: '062097f1b1f34e11e7f82aag22000aee',
  chocomemberAppId: '86a6b258-ac30-4816-bc14-a31e514226d7',
}

// export const apiHost = 'https://api.linetv.tw'
export const apiHost = 'https://cheetahmen.chocotv.com.tw'
export const adHost = 'https://madmen.chocolabs.com'
export const eventHost = 'https://eventservice.chocolabs.com'
export const chocomemberHost = 'https://membertest.chocolabs.com';
export const staticHost = 'https://static-beta.linetv.tw';

export const CLEAN_CACHE_TOKEN = '274c716541ecc57c9c1ae62543fdfff43f056c8a'

// dramas
export const FETCH_DRAMA_URL = `${apiHost}/v2/dramas?appId=${chocotvWeb.appId}&countryCode=TW&languageId=zh&version=${version}&chocomemberAppId=${chocotvWeb.chocomemberAppId}`
export const FETCH_INDEX_URL = `${apiHost}/v2/index?appId=${chocotvWeb.appId}&countryCode=TW&languageId=zh&chocomemberAppId=${chocotvWeb.chocomemberAppId}&version=${version}`
export const fetchDramaInfoURL = dramaId => `${apiHost}/v1/dramas/${dramaId}/info?countryCode=TW&version=${version}&languageId=zh&appId=${chocotvWeb.appId}&chocomemberAppId=${chocotvWeb.chocomemberAppId}`

export const INTERNAL_FETCH_DRAMA_URL = FETCH_DRAMA_URL;
export const internalFetchDramaInfoURL = fetchDramaInfoURL;

export const HOME_BANNERS_DATA = 'https://img.linetv.tw/WEB/api/staging/web_banners.json';

// Server Side APIs
export const localFetchDrama = isBrowser ? '/api/drama' : `http://localhost:${process.env.PORT}/api/drama`
export const localFetchDramaInfo = (dramaId) => isBrowser ? `/api/dramaInfo/${dramaId}` : `http://localhost:${process.env.PORT}/api/dramaInfo/${dramaId}`

// smartdata
export const smartdataHost = 'https://smartdata.linetv.tw'

// chocomember
export const chocomemberEmailUrl = `${chocomemberHost}/auth/local`
export const chocomemberProfileUrl = `${chocomemberHost}/account/profile`
export const chocomemberRevokeUrl = `${chocomemberHost}/auth/token/revoke`
export const putUser = `${apiHost}/user/user`
